
export class Layout {

  private columnSize: number;

  constructor(
    size: number,
    private nbColumns: number,
    private gutterSize: number
  ) {
    const nbGutter = nbColumns - 1;
    this.columnSize = (size - (nbGutter * gutterSize)) / nbColumns;
  }

  getNbColumns(): number {
    return this.nbColumns;
  }
  
  getSize(nbColumns: number = this.nbColumns): number {
    if (nbColumns < 0 || nbColumns > this.nbColumns || Math.round(nbColumns) !== nbColumns) {
      console.warn(`Invalid nbColumns : ${nbColumns}`);
      return 0;
    }
    if (nbColumns === 0) {
      return 0;
    }
    return (nbColumns * this.columnSize) + ((nbColumns - 1) * this.gutterSize);
  }

  getPosition(postition: number): number {
    if (postition < 0 || postition > this.nbColumns || Math.round(postition) !== postition) {
      console.warn(`Invalid postition : ${postition}`);
      return 0;
    }
    return (this.columnSize + this.gutterSize) * postition;
  }

}


// WEBPACK FOOTER //
// src/app/src/utils/Layout.ts